import { $getNodeByKey, LexicalEditor, NodeKey } from 'lexical';
import { findScrollContainer } from './findScrollContainer';

export async function scrollToNode(editor: LexicalEditor, key: NodeKey) {
  const element = editor.getElementByKey(key);
  if (!element) return;

  const scrollContainer = findScrollContainer(editor.getRootElement());

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });

  if (scrollContainer) {
    await waitForScrollEnd(scrollContainer);
  }

  requestAnimationFrame(() => {
    editor.update(() => {
      $getNodeByKey(key)?.selectStart();
    });
  });
}

function waitForScrollEnd(element: Element): Promise<void> {
  return new Promise(resolve => {
    let timeoutId: number;

    function bumpTimeout() {
      clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        element.removeEventListener('scroll', bumpTimeout);
        resolve();
      }, 100);
    }

    element.addEventListener('scroll', bumpTimeout);
    bumpTimeout();
  });
}
